import styled from 'styled-components';

const hexToRgba = (hex: string, opacity: number) => {
  const bigint = parseInt(hex.slice(1), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export const Wrapper = styled.section`
    position: absolute;
    left: 0;
    display: flex;
    width: 100vw;
    top: 44px;
    min-height: calc(100vh - 44px);
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    animation: ease-out, fadeIn 0.2s ease-out;
    overflow-y: scroll;
    overflow-x: hidden;

    @media (min-width: 1200px) {
        flex-direction: row;
        margin-top: 0;
        margin-bottom: 0;
    }
`;

export const Aside = styled.aside`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 300px;
  border-right: 1px solid #e0e0e0;
  background: linear-gradient(135deg, #070707, #0C0B0A, #081214, #0C0B0A, #070707);
  flex-shrink: 0;

  @media (min-width: 1200px) {
    width: 35%;
    height: calc(100vh - 44px);
  }
`;

export const SquareWhite = styled.section`
    position: absolute;
    width: 180px;
    height: 180px;
    background: #fff;
    border-radius: 15px;
    rotate: -5deg;

    @media (min-width: 1200px) {
        width: 292px;
        height: 292px;
    }
`;

export const SquareImageEvent = styled.section`
    position: absolute;
    width: 180px;
    height: 180px;
    border-radius: 15px;
    rotate: 5deg;

    @media (min-width: 1200px) {
        width: 292px;
        height: 292px;
    }
`;

export const ImageEvent = styled.img`
    width: 100%;
    height: 100%;
    object-fit: fill;
    border-radius: 15px;
    border: 1px solid rgba(224, 224, 224, 0.2);
`;

export const Main = styled.main`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 2rem;
    background: #fff;
    overflow-y: scroll;
    height: calc(100vh - 44px - 300px);
    padding-bottom: 8rem;

    @media (min-width: 1200px) {
        width: 65%;
        height: calc(100vh - 44px);
        justify-content: center;
        padding-bottom: 2rem;
    }
`;

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    height: auto;
    gap: 1rem;

    @media (min-width: 1200px) {
        width: 584px;
    }
`;

export const Title = styled.h1`
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 19.6px;
    text-align: left;
    margin-bottom: 0.6rem;
    `;

export const Subtitle = styled.h2`
    font-family: "MADE TOMMY";
    font-size: 32px;
    font-weight: 700;
    line-height: 44.8px;
    text-align: left;
    text-transform: uppercase;
    margin-bottom: 0.4rem;
`;

export const EventTitle = styled.h3`
    font-family: Inter;
    font-size: 16px;
    font-weight: 700;
    line-height: 22.4px;
    text-align: left;
`;

export const ContainerLocation = styled.section`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.3rem;
    margin-top: -0.7rem;
`;

export const Location = styled.span`
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
    text-align: left;
`;

export const TitleEventDate = styled.h4`
    font-family: Inter;
    font-size: 16px;
    font-weight: 600;
    line-height: 19.36px;
    text-align: left;
    margin-top: 0.5rem;
`;

export const EventDate = styled.span`
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
    text-align: left;
    margin-top: -0.7rem;
`;

export const DetailsSendEmail = styled.span`
    font-family: Inter;
    font-size: 16px;
    font-weight: 600;
    line-height: 19.36px;
    text-align: left;
    margin-top: 0.5rem;
`;

export const EmailText = styled.span`
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
    text-align: left;
    margin-top: -0.7rem;
`;

export const ContainerButtons = styled.section`
    display: flex;
    width: 100%;
    gap: 1rem;
    margin-top: 1.5rem;

    @media (min-width: 1200px) {
        width: 582px;
    }
`;

export const ContainerInfo = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 12px;
    gap: 0.5rem;
    border-radius: 8px;
    margin-bottom: 0.5rem;
    background-color: ${({ theme }) => hexToRgba(theme.colors.info, 0.2)};
`;

export const RowInfo = styled.section`
    position: relative;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: flex-start;
    gap: 0.5rem;
`;

export const TextInfo = styled.span`
    font-family: Inter;
    font-size: 14px;
    font-weight: 600;
    line-height: 16.94px;
    text-align: left;
    color: #005299;
    margin-top: 0.1rem;
`;

export const TextInfoPartial = styled(TextInfo)`
    color: #004799;
    font-weight: 400;
    margin-left: 1.2rem;
`;

export const Dot = styled(TextInfo)`
    position: absolute;
    top: -0.6rem;
    left: 0.2rem;
    font-size: 32px;
`;
